<script setup lang="ts">
import ChatWindow from './components/ChatWindow.vue'
import ChatList from './components/ChatList.vue'
import { ref } from 'vue'

const isSidebarOpen = ref(false)

function toggleSidebar() {
  isSidebarOpen.value = !isSidebarOpen.value
}
</script>

<template>
  <div class="flex h-screen">
    <!-- 移动端侧边栏遮罩 -->
    <div 
      v-if="isSidebarOpen" 
      class="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
      @click="toggleSidebar"
    ></div>

    <!-- 侧边栏 -->
    <div 
      :class="[
        'fixed lg:static inset-y-0 left-0 z-30 transform transition-transform duration-300 ease-in-out',
        'w-72 lg:translate-x-0',
        isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
      ]"
    >
      <ChatList @close-sidebar="toggleSidebar" />
    </div>

    <!-- 主聊天区域 -->
    <div class="flex-1 relative">
      <!-- 移动端菜单按钮 -->
      <button
        class="lg:hidden absolute top-3 left-4 z-10 p-2 rounded-md hover:bg-gray-100"
        @click="toggleSidebar"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>
      <ChatWindow />
    </div>
  </div>
</template>

<style>
/* 防止侧边栏打开时页面滚动 */
.overflow-hidden {
  overflow: hidden;
}
</style> 